'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

let p = {
    showBannerOnly: deprecatedProp(e$1.bool, 'To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.')
}, s = Object.keys(p);
const PriceBar = renderWithRef('PriceBar', p, (e$1, o)=>{
    useComponentStylesLoaded('PriceBar', SWAN_STYLE_KEY_MAP.priceBar);
    let { showBannerOnly: t, children: p } = e$1, c = new Set([
        'swan-price-bar'
    ]);
    return t && c.add("swan-price-bar-show-banner"), e.createElement(RenderComp, {
        root: "div",
        forwardedRef: o,
        propKeysToRemove: s,
        classNames: c,
        props: e$1
    }, e.createElement("div", {
        className: "swan-price-bar-inner"
    }, p));
});

export { PriceBar };
